import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import FilterSelection, {
  SELECTION_TOTAL_HEIGHT,
  SELECTION_LAST_BOTTOM_MARGIN,
} from './FilterSelection';

import { ButtonLinkText } from '../Buttons/ButtonLink';

import { DESKTOP_START_QUERY } from '../../../styling/mixins/responsive';

const MAX_DISPLAYED_FILTERS = 3;

const FilterListContainer = styled.div`
  display: flex;
  flex-flow: column;
  padding: 0 1.5rem;
  background-color: #fff;

  @media (${DESKTOP_START_QUERY}) {
    padding: 0;

    /** styles for open/close **/
    max-height: ${({ containerSize }) =>
      containerSize * SELECTION_TOTAL_HEIGHT +
      SELECTION_LAST_BOTTOM_MARGIN +
      'rem'};
    transition: max-height 0.5s ease-in-out;
    overflow: hidden;

    &.collapsed {
      max-height: 0;
    }
  }
`;

const ViewMoreContainer = styled.div`
  padding: 0.5rem 0 1.5rem 2.4rem;

  span {
    font-size: 0.625rem;
    line-height: 0.625rem;
  }

  @media (${DESKTOP_START_QUERY}) {
    padding: 0 0 1.5rem;
  }
`;

export const FilterList = ({
  className,
  filterGroupData,
  filterType,
  isMobile,
  isCollapsed = false,
}) => {
  const [shouldHideMoreFilters, setShouldHideMoreFilters] = useState(true);
  const { values, slug } = filterGroupData;
  const canHideFilters =
    slug === 'themes' ||
    slug === 'designers' ||
    slug === 'package-properties-theme';
  const hasHiddenFilters =
    shouldHideMoreFilters &&
    canHideFilters &&
    values.length > MAX_DISPLAYED_FILTERS;
  const outputRange = hasHiddenFilters
    ? values.slice(0, MAX_DISPLAYED_FILTERS)
    : values;

  // when filters change, reset state
  const filterNames = values.map(filter => filter.name);
  useEffect(() => {
    if (!shouldHideMoreFilters) {
      setShouldHideMoreFilters(true);
    }
  }, filterNames);

  const ViewMoreLink = (
    <ButtonLinkText
      color={'gatsby'}
      onClick={() => setShouldHideMoreFilters(false)}
    >
      {isMobile ? 'View More' : 'more'}
    </ButtonLinkText>
  );

  return (
    <FilterListContainer
      className={`${className} ${isCollapsed ? 'collapsed' : ''}`}
      containerSize={outputRange.length + (hasHiddenFilters ? 1 : 0)}
    >
      {outputRange.map(filter => {
        return (
          <FilterSelection
            key={filter.name}
            filterType={filterType}
            name={filter.name}
            type={filter.type}
            value={filter.value}
            on={filter.on}
            isMobile={isMobile}
          />
        );
      })}
      {hasHiddenFilters ? (
        <ViewMoreContainer>{ViewMoreLink}</ViewMoreContainer>
      ) : null}
    </FilterListContainer>
  );
};

FilterList.propTypes = {
  filterGroupData: PropTypes.object.isRequired,
  filterType: PropTypes.oneOf(['sort', 'filter']).isRequired,
  isCollapsed: PropTypes.bool,
  isMobile: PropTypes.bool.isRequired,
};

export default FilterList;
